import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HairmodelComponent } from './hairmodel.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [HairmodelComponent],
  exports: [
    HairmodelComponent
  ],
  providers: [
  ]
})
export class HairmodelModule { }
